(function () {
  'use strict';

  function addDays(date, amount, businessDaysOnly) {
    var result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var remaining = Math.max(0, Number(amount) || 0);
    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (!businessDaysOnly || (day !== 0 && day !== 6)) remaining -= 1;
    }
    return result;
  }

  function formatDate(date) {
    try {
      return new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
        month: 'short',
        day: 'numeric'
      }).format(date);
    } catch (error) {
      return date.toLocaleDateString();
    }
  }

  function hydrate(element) {
    if (!element || element.dataset.deliveryHydrated === 'true') return;
    element.dataset.deliveryHydrated = 'true';
    var target = element.querySelector('[data-delivery-date-range]');
    if (!target || element.dataset.knownMarket !== 'true') return;
    if (element.hasAttribute('data-made-to-order-delivery') && element.dataset.processingKnown !== 'true') return;

    var today = new Date();
    var processingMin = Number(element.dataset.processingMin || 0);
    var processingMax = Number(element.dataset.processingMax || 0);
    var transitMin = Number(element.dataset.transitMin || 0);
    var transitMax = Number(element.dataset.transitMax || 0);
    var transitBusiness = element.dataset.transitBusiness === 'true';
    var earliestDispatch = addDays(today, processingMin, true);
    var latestDispatch = addDays(today, processingMax, true);
    var earliest = addDays(earliestDispatch, transitMin, transitBusiness);
    var latest = addDays(latestDispatch, transitMax, transitBusiness);
    target.textContent = formatDate(earliest) + '–' + formatDate(latest);
    target.removeAttribute('hidden');
  }

  function hydrateAll(scope) {
    (scope || document).querySelectorAll('[data-delivery-estimate]').forEach(hydrate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hydrateAll(document); });
  } else {
    hydrateAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { hydrateAll(event.target); });
})();
